import request from "../utils/request";
export function getGame(params) {
  return request({
    url: "/api/game",
    method: "get", // 或 'post'，根据后端接口决定
    params, // 如果是 post 请求，改为 data: params
  });
}
export function getNew(params) {
  return request({
    url: "/api/news",
    method: "get", // 或 'post'，根据后端接口决定
    params, // 如果是 post 请求，改为 data: params
  });
}
export function getJoin(params) {
  return request({
    url: "/api/job",
    method: "get", // 或 'post'，根据后端接口决定
    params, // 如果是 post 请求，改为 data: params
  });
}
